import { render, staticRenderFns } from "./QuestionnaireGroups.vue?vue&type=template&id=258c2da6&scoped=true&"
import script from "./QuestionnaireGroups.vue?vue&type=script&lang=js&"
export * from "./QuestionnaireGroups.vue?vue&type=script&lang=js&"
import style0 from "./QuestionnaireGroups.vue?vue&type=style&index=0&id=258c2da6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "258c2da6",
  null
  
)

component.options.__file = "QuestionnaireGroups.vue"
export default component.exports